module.exports = __webpack_public_path__ + "img/reverso.24c77b20.png";